import React from 'react';
import emailjs from 'emailjs-com';

const Contact = () => {
  const sendEmail = (event) => {
    event.preventDefault();
    emailjs
      .sendForm(
        'service_jg1wfhq',
        'template_s8d7ylq',
        event.target,
        'l4Or0Dnd39yITfRH4'
      )
      .then((res) => {
        console.log(res);
      })
      .catch((err) => console.log(err));
  };

    return (
      

      <div 
        
      style={{
        backgroundImage: "url('https://vproduction.com/wp-content/themes/vprod/assets/img/svg/menu-background.svg')",
backgroundPosition: 'center',
backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            
    }}
        className='bg-[#090222]'>
            
    <div id="contact" class="hero min-h-screen ">
      <div class="hero-content flex-col lg:flex-row-reverse ">
        <div class="text-center lg:text-left">
          <h1 class="text-4xl font-bold lg:w-96 text-center">Contact With Me</h1>
          <div className="flex  gap-4 items-center justify-center mt-4">
            <div className="w-[52px] h-[52px] bg-[#090222] flex items-center justify-center">
              <a
                className="text-white text-4xl"
                href="https://www.facebook.com/progshahidul/"
                target="_blank"
              >
                <ion-icon name="logo-facebook"></ion-icon>{' '}
              </a>
            </div>
            <div className="w-[52px] h-[52px] bg-[#090222] flex items-center justify-center">
              <a
                className="text-white text-4xl"
                href="https://www.linkedin.com/in/progshahidul/"
                target="_blank"
              >
                <ion-icon name="logo-linkedin"></ion-icon>
              </a>
            </div>
            <div className="w-[52px] h-[52px] bg-[#090222] flex items-center justify-center">
              <a
                className="text-white text-4xl"
                href = "mailto:shahidulislam1474@gmail.com" target="_top"
              
              >
                <ion-icon name="mail"></ion-icon>
              </a>
            </div>
          </div>
        </div>
        <div class="card flex-shrink-0 sm:max-w-sm  md:w-full  shadow-2xl bg-[#0E1B31]"
        
                 
      style={{
        backgroundImage: "url('https://vproduction.com/wp-content/themes/vprod/assets/img/svg/menu-background.svg')",
backgroundPosition: 'center',

            backgroundRepeat: 'no-repeat',
            
    }}
            >
          <div class="card-body ">
            <form onSubmit={sendEmail}>
              <div class="form-control opacity-60">
                <label class="label">
                  <span class="label-text text-white">Name</span>
                </label>
                <input
                  type="text"
                  name="name"
                  placeholder="name"
                  class="input input-bordered"
                />
              </div>
              <div class="form-control opacity-60">
                <label class="label">
                  <span class="label-text text-white">Email</span>
                </label>
                <input
                  type="email"
                  name="user_email"
                  placeholder="email"
                  class="input input-bordered"
                />
              </div>
              <div class="form-control opacity-60">
                <label class="label">
                  <span class="label-text text-white">Bio</span>
                </label>

                <textarea
                  class="textarea textarea-bordered"
                  name="message"
                  placeholder="Bio"
                ></textarea>
              </div>
              <div class="form-control mt-6">
                <button class="btn  bg-indigo-800 border-0">Send</button>
              </div>
            </form>
          </div>
        </div>
      </div>
            </div>
            </div>
  );
};

export default Contact;
